<div class="sc-container">
  <router-outlet></router-outlet>
</div>
